import { styled } from '@mui/material';
import { messenger } from '@side/next-zendesk-sdk';
import { Alert, AlertButton } from '@side/pantry';
import { useRouter } from 'next/router';

const StyledUnderline = styled('u')`
  cursor: pointer;
`;

export function MLSErrorBanner() {
  const router = useRouter();

  return (
    <Alert
      severity="error"
      square
      variant="stacked"
      action={
        <AlertButton severity="error" onClick={() => router.reload()}>
          Reload
        </AlertButton>
      }
    >
      There was an error generating MLS vendors. Please try again by reloading
      the page. If this issue persists please contact{' '}
      <StyledUnderline
        onClick={() => messenger.open()}
        role="link"
        tabIndex={0}
      >
        Side Support
      </StyledUnderline>{' '}
      for assistance.
    </Alert>
  );
}
